import React, { useState, useMemo } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const ReportedItemModal = ({ open, onClose, show, report, item, itemType, otherReports, onSubmitReport, id, updateReport }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [displayImage, setDisplayImage] = useState(true);
    const [actionMode, setActionMode] = useState(null);
    const [actionNotes, setActionNotes] = useState('');
    const [completedActions, setCompletedActions] = useState({});
    const [currentReportIndex, setCurrentReportIndex] = useState(0);
    const reports = useMemo(() => {
        if (!report) return [];

        const filteredOthers = otherReports.filter(r => r.id !== report.id);

        return [report, ...filteredOthers];
    }, [report, otherReports]);
    const activeReport = reports[currentReportIndex];
    const totalReports = reports.length;
    const hasMultipleReports = totalReports > 1;
    const [showReasonError, setShowReasonError] = useState(false);
    
    if (!open || !item || !report) {
        return null;
    }

    const itemCreatedAt = item?.created_at ? new Date(item.created_at).toLocaleString() : '';


    const handlePrevImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === 0 ? item.images.length - 1 : prevIndex - 1
        );
    };

    const handleNextImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === item.images.length - 1 ? 0 : prevIndex + 1
        );
    };

    const goPrevReport = () => {
        setCurrentReportIndex(i => 
            i === 0 ? totalReports - 1 : i - 1
        );
    };

    const goNextReport = () => {
        setCurrentReportIndex(i => 
            i === totalReports - 1 ? 0 : i + 1
        );
    };


    const reportUser = (userId, reason) => {
        onSubmitReport({
            reportedId: userId,
            itemId: userId,
            itemType: "USER",
            reason: reason,
            reporterId: id
        });
    };

    const reportReporter = (input) => {
        if (!input.trim()) {
            setShowReasonError(true);
            return;
        }
        reportUser(activeReport.reporter.id, `Reporting reporter for: ${input}`);
    };

    const reportOwner = (input) => {
        if (!input.trim()) {
            setShowReasonError(true);
            return;
        }
        const userId = item.user.id
        reportUser(userId, `Rereporting owner of reported item: ${input}`);
    };


    const updateReportsStatus = (status, moderatorNotes) => {
        if (!moderatorNotes.trim()) {
            setShowReasonError(true);
            return;
        }

        if (!reports || reports.length === 0) return;
        //
        const reportIds = reports.map(r => r.id);

        updateReport({
            reportIds,
            status,
            itemId: item.id,
            itemType,
            reviewerId: id,
            moderatorNotes
        })

        onClose();
    }

    return (
        <Modal
            show={show}
            onHide={onClose}
            size="lg"
            aria-labelledby="custom-modal-styling"
            className="custom-modal"
            fullscreen="lg-down"
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div>Owner - {item.actorUsername}</div>
                    <div>Character - {item.character}</div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                    <Button variant="outline-secondary" onClick={() => setDisplayImage(!displayImage)}>
                        {displayImage ? '-' : '+'}
                    </Button>
                </div>
                <div className="text-center">
                    {itemType === 'SKETCH' && displayImage && (
                        <img
                            src={item.images[currentImageIndex]?.presignedUrl}
                            alt="morph"
                            style={{
                            maxWidth: "100%",
                            objectFit: 'contain',
                            margin: '5px'
                            }}
                        />
                    )}

                    {itemType === 'MORPH' && item.images?.length > 0 && displayImage && (
                            <div className="text-center">
                                <img
                                    src={item.images[currentImageIndex]?.presignedUrl}
                                    alt="morph"
                                    style={{
                                    maxWidth: "100%",
                                    objectFit: 'contain',
                                    margin: '5px'
                                    }}
                                />
                                <div className="mt-2">
                                    <Button variant="secondary" onClick={handlePrevImage}>Prev</Button>{' '}
                                    <Button variant="secondary" onClick={handleNextImage}>Next</Button>
                                </div>
                            </div>
                    )}
                </div>

                <div className="mt-4 d-flex flex-column  justify-content-between gap-3">
                    <div className="card" style={{ flex: 5, backgroundColor: "#2b2d31" }}>
                        <div className="card-body">
                            {itemType === 'SKETCH' && (
                                <div>
                                    <h5 className="card-title" style={{ color: "white" }}>Description:</h5>
                                    <p className="card-text">Description: {item.description}</p>
                                    <p className="card-text " >Sketcher - {item.sketcher}</p>
                                    <p className="card-text">Card Code - {item.cardCode}</p>
                                    <p className="card-text">Series - {item.series}</p>
                                    <p className="card-text">Inkwell - {item.inkwell}</p>
                                    <p className="card-text border-bottom">Created At: {itemCreatedAt}</p>
                                </div>
                            )}
                            {itemType === 'MORPH' && (
                                <div>
                                    <p className="card-text">Description: {item.description}</p>
                                    <p className="card-text">Card Code - {item.cardCode}</p>
                                    <p className="card-text border-bottom">Created At: {itemCreatedAt}</p>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="card mt-4" style={{ flex: 7,backgroundColor: "#2b2d31" }}>
                        <div className="card-body">
                            <div>
                                <h5 className="card-title" style={{ color: "white" }}>Reports</h5>

                                <div className="d-flex justify-content-between align-items-center mb-3">
                                <Button size="sm" variant="secondary" disabled={!hasMultipleReports} onClick={goPrevReport}>Prev</Button>
                                <span>Report 1 of {totalReports}</span>
                                <Button size="sm" variant="secondary" disabled={!hasMultipleReports} onClick={goNextReport}>Next</Button>
                                </div>

                                <p><strong>Reason -</strong> {activeReport.reason}</p>
                                <p><strong>Reported At:</strong> {new Date(activeReport.createdAt).toLocaleString()}</p>
                                <p><strong>Reported By:</strong> {activeReport.reporter?.username}</p>

                                <hr />
                            </div>
                            <div>
                                <div>
                                    {showReasonError && (
                                        <Form.Text style={{ color: 'red' }}>Please enter a reason before submitting.</Form.Text>
                                    )}
                                </div>
                                {actionMode === null && (
                                <Form.Group className="mb-3">
                                    <Form.Label>Moderator Notes</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={actionNotes}
                                        onChange={(e) => setActionNotes(e.target.value)}
                                        placeholder="Internal moderation notes..."
                                    />
                                </Form.Group>
                                )}

                                {actionMode !== null && (
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {actionMode === 'REPORT_OWNER'
                                            ? 'Reason for reporting item owner'
                                            : 'Reason for reporting reporter'
                                        }
                                    </Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={actionNotes}
                                        onChange={(e) => setActionNotes(e.target.value)}
                                        placeholder="This will be sent to admins"
                                    />
                                    
                                </Form.Group>
                                )}
                            </div>

                            <div className="d-flex justify-content-end gap-2">
                                <Button variant="outline-success" disabled={actionMode !== null} onClick={() => updateReportsStatus('DISMISSED', actionNotes)}>Dismiss</Button>
                                <Button variant="outline-warning" disabled={actionMode !== null} onClick={() => updateReportsStatus('RESOLVED', actionNotes)}>Delete Item</Button>
                                <Button
                                    variant={actionMode === 'REPORT_OWNER' ? 'danger' : 'outline-danger'}
                                    disabled={completedActions.REPORT_OWNER}
                                    onClick={() => {
                                        if (actionMode === 'REPORT_OWNER') {
                                            reportOwner(actionNotes);
                                            setCompletedActions(prev => ({ ...prev, REPORT_OWNER: true }));
                                            setActionMode(null);
                                            setActionNotes('');
                                        } else {
                                            setActionMode('REPORT_OWNER');
                                            setActionNotes('');
                                        }
                                    }}
                                    >
                                    {completedActions.REPORT_OWNER
                                        ? 'Owner Reported'
                                        : actionMode === 'REPORT_OWNER'
                                        ? 'Confirm Report Owner'
                                        : 'Report Owner'}
                                </Button>
                                <Button
                                    variant={actionMode === 'REPORT_REPORTER' ? 'danger' : 'outline-danger'}
                                    onClick={() => {
                                        if (actionMode === 'REPORT_REPORTER') {
                                            reportReporter(actionNotes);
                                            setActionMode(null);
                                            setActionNotes('');
                                        } else {
                                            setActionMode('REPORT_REPORTER');
                                            setActionNotes('');
                                        }
                                    }}
                                    >
                                    {actionMode === 'REPORT_REPORTER' ? 'Confirm Report Reporter' : 'Report Reporter'}
                                </Button>
                                {(actionMode === 'REPORT_REPORTER' || actionMode === 'REPORT_REPORTER') && (
                                    <Button variant="outline-secondary" 
                                    onClick={() => {
                                        setActionMode(null);
                                        setActionNotes('');
                                    }}
                                    >Cancel</Button>
                                )}
                                
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ReportedItemModal;